import {useState} from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import h from 'react-hyperscript';
import {ListItem, ListItemText} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import {h4} from 'Components/Typography/Typography';

export default function ArchiveDropdown(props) {
  const districtName = props.districtNames.length ?
      props.districtNames[0].name : 'District Name Unavailable';
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterText, setFilter] = useState(props.districtName || districtName);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const updateFilter = (district) => {
    setFilter(district.name);
    props.setDistrictFilter(district);
  };

  return (
    h('div', [
      h(ListItem, {
        onClick: handleOpen,
        className: 'archive__dropdown-button' +
        (Boolean(anchorEl) ? ' archive__dropdown-open' : ''),
      },
      [
        h(h4, filterText),
            Boolean(anchorEl) ? h(ArrowDropUpIcon) : h(ArrowDropDownIcon),
      ]
      ),
      h(Menu, {
        timeout: 'auto',
        anchorEl: anchorEl,
        keepMounted: true,
        elevation: 1,
        getContentAnchorEl: null,
        open: Boolean(anchorEl),
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
        onClose: handleClose,
      }, [
        props.districtNames.map((district) => {
          return h(MenuItem, {
            button: true,
            className: 'archive__dropdown-item',
            onClick: () => {
              updateFilter(district);
              handleClose();
            },
            key: district.id,
          }, [
            h(ListItemText, {
              primary: district.name,
            }),
          ]);
        }),
      ]),
    ])
  );
}
